<template>
  <div class="container">    
    <div class="row my-5">
      <div class="col-12 text-center">
        <div class="intro py-3">Lorem ipsum dolor sit.</div>  

        <div id="carouselImages" class="carousel slide central" data-bs-ride="carousel">      
          <div class="carousel-inner">
            <div class="carousel-item active">
              <imageElement :imageData="imageDataScroll(items[0])" :position="items[0].position" />
              <div v-if="items[0].imageCredits" class="text-left creditos-picture">
          {{ items[0].imageCredits }}
        </div>
            </div>
            <div class="carousel-item">
              <imageElement :imageData="imageDataScroll(items[1])"  :position="items[1].position" />
              <div v-if="items[0].imageCredits" class="text-left creditos-picture">
          {{ items[0].imageCredits }}
        </div>
            </div>
            <div class="carousel-item">
              <imageElement :imageData="imageDataScroll(items[2])" :position="items[2].position" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselImages" role="button" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselImages" role="button" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </a>
        </div>

        
      </div>      
    </div>
  </div> 
</template>


<script>

import images from '@/mixins/images'

export default {
  name: "CarouselGrid",
  mixins: [images],
  props: {
    items: Array
  }
}

</script>

<style>
.carousel-inner {
  max-width: 720px;
  margin:0 auto;
  min-height: 220px;
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
}

.carousel-control-prev-icon {
  background-color: #000;  
}

.carousel-control-next-icon {
  background-color: #000;  
}

</style>